export default [
  {
    path: '/logs',
    name: 'logs',
    component: () =>
      import(
        /* webpackChunkName: "logs" */ '@/modules/logs/_views/LogPanelIndex'
      ),
    meta: { section: 'logs', allowedRoles: ['ROLE_SUPER_ADMIN'] },
    redirect: { name: 'office_log' },
    children: [
      {
        name: 'office_log',
        path: 'office_log',
        component: () =>
          import(
            /* webpackChunkName : "cards-log" */ '@/modules/logs/_views/OfficeLogPanel'
          ),
        meta: { section: 'logs', allowedRoles: ['ROLE_SUPER_ADMIN'] }
      },
      {
        name: 'user_log',
        path: 'user_log',
        component: () =>
          import(
            /* webpackChunkName : "user-log" */ '@/modules/logs/_views/UserLogPanel'
          ),
        meta: { section: 'logs', allowedRoles: ['ROLE_SUPER_ADMIN'] }
      },
      {
        name: 'cards_log',
        path: 'cards_log',
        component: () =>
          import(
            /* webpackChunkName : "cards-log" */ '@/modules/logs/_views/CardLogPanel'
          ),
        meta: { section: 'logs', allowedRoles: ['ROLE_SUPER_ADMIN'] }
      },
      {
        name: 'webhook_log',
        path: 'webhook_log',
        component: () =>
          import(
            /* webpackChunkName : "cards-log" */ '@/modules/logs/_views/WebHookLogPanel'
          ),
        meta: { section: 'logs', allowedRoles: ['ROLE_SUPER_ADMIN'] }
      }
    ]
  }
]
